import { createFileRoute, redirect } from '@tanstack/react-router';

import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/negotiations/$negotiationId/')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'none' } satisfies PageStaticData,
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/negotiations/$negotiationId/overview',
            params: { negotiationId: params.negotiationId },
            replace: true,
        });
    },
});
